import { ActionType } from '../infrastructure/actionTypes';
import { IOrderCostReportRow } from '../infrastructure/interfaces'

export default (list: Array<IOrderCostReportRow> = [], action: any) => {
  switch (action.type) {
    case ActionType.GET_ORDER_COST_REPORT_DONE:
      return [...action.costReportRows];
    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/orderCostReport.ts